export const sv = {
  tagline: 'Logga in till verkstadsportalen',
  emailHeading: 'Ange e-postadress',
  emailLabel: 'E-post',
  emailPlaceholder: 'namn@foretag.se',
  sendCode: 'Skicka kod',
  otpHeading: 'Ange verifieringskod',
  otpSentTo: 'Vi har skickat en kod till',
  otpLabel: 'Verifieringskod',
  login: 'Logga in',
  changeEmail: 'Ändra e-postadress',
  errInvalidEmail: 'Ogiltig e-postadress. Ange en giltig e-post.',
  errSendOtp: 'Kunde inte skicka OTP. Försök igen.',
  errGeneric: 'Något gick fel. Försök igen.',
  errNoAccess: 'Du har inte tillgång till garageportalen. Endast verkstäder kan logga in här.',
  errWrongCode: 'Felaktig kod. Försök igen.',
}

export const en: typeof sv = {
  tagline: 'Log in to your garage',
  emailHeading: 'Enter email address',
  emailLabel: 'Email',
  emailPlaceholder: 'name@company.com',
  sendCode: 'Send code',
  otpHeading: 'Enter verification code',
  otpSentTo: 'We sent a code to',
  otpLabel: 'Verification code',
  login: 'Log in',
  changeEmail: 'Change email address',
  errInvalidEmail: 'Invalid email address. Please enter a valid email.',
  errSendOtp: 'Could not send the code. Try again.',
  errGeneric: 'Something went wrong. Try again.',
  errNoAccess: 'You do not have access to the garage portal. Only garages can log in here.',
  errWrongCode: 'Incorrect code. Try again.',
}
